import {MeetingCommentFile} from './MeetingCommentFile'
import {NatAsyncCallFunction} from '../../../__NoAutomatedTests/common/util/Natutil'
import {MeetingRepositoryForResident} from '../MeetingRepositoryForResident'
import UpdateMeetingComment from './UpdateMeetingComment'
import {InputError} from '../components/MeetingCommentInputForm'
import EventEmitterEx from '../../shared/pageBaseComponents/EventEmitterEx'
import {Nullable} from '../../../app/TypeHelpers'
import {SubmitCommentAndFilesTemplateForResident} from './SubmitCommentAndFilesTemplateForResident'
import {FileDataForValidate} from './FileDataForValidate'
import {NavigateFunction} from 'react-router-dom'

interface SendData {
    condominiumCd: string
    meetingId: number
    commentId: number
    updateMeetingComment: UpdateMeetingComment
}

export class SubmitUpdateCommentProcedure extends SubmitCommentAndFilesTemplateForResident<SendData> {
    meetingRepoForResident: MeetingRepositoryForResident
    navigate: NavigateFunction

    constructor(
        registerCommentError: (inputError: InputError) => void,
        meetingRepoForResident: MeetingRepositoryForResident,
        eventEmitter: EventEmitterEx,
        navigate: NavigateFunction,
    ) {
        super(registerCommentError, eventEmitter)
        this.meetingRepoForResident = meetingRepoForResident
        this.navigate = navigate
    }

    async innerRegisterComment(sendData: SendData): Promise<Nullable<number>> {
        const result = await NatAsyncCallFunction(
            this.meetingRepoForResident.updateComment.bind(
                this.meetingRepoForResident,
                sendData.condominiumCd,
                sendData.meetingId,
                sendData.commentId,
                sendData.updateMeetingComment,
            ),
            this.navigate,
        )
        if (result === null) {
            return null
        }
        return sendData.commentId
    }

    async innerValidateFile(fileDataForValidate: FileDataForValidate): Promise<Nullable<void>> {
        return await NatAsyncCallFunction(
            this.meetingRepoForResident.validateParallelFileUpload.bind(
                this.meetingRepoForResident,
                fileDataForValidate,
            ),
            this.navigate,
        )
    }

    async registerFile(sendData: SendData, commentId: number, commentFile: MeetingCommentFile): Promise<void> {
        // NatAsyncCallFunctionによる標準の通信エラー処理を行わない
        // 原因はなんであれファイルを再登録する必要があることをユーザーに伝える必要があるため、全ての例外を捕捉する
        await this.meetingRepoForResident.registerCommentFile(
            sendData.condominiumCd,
            sendData.meetingId,
            commentId,
            commentFile,
        )
    }

    async submit(
        condominiumCd: string,
        meetingId: number,
        commentId: number,
        updateMeetingComment: UpdateMeetingComment,
        commentFileList: MeetingCommentFile[],
    ): Promise<boolean> {
        return await this.process(
            {
                condominiumCd: condominiumCd,
                meetingId: meetingId,
                commentId: commentId,
                updateMeetingComment: updateMeetingComment,
            },
            commentFileList,
        )
    }
}
